import { ContentTag } from "sj-ui-toolkit/src/atlas/components";

import S from "./_Lesson.module.scss";

export default function LessonInfo({ lessonType, title, description, level, duration }) {
  return (
    <div data-test-id="lesson-info" className={S.lessonInfo}>
      <div>
        <ContentTag value={lessonType} />
        <h1 className="atlas-h4 mt-4.5 mb-2">{title}</h1>
        <p>{description}</p>
      </div>
      <div className="flex flex-row mt-6 body-sm">
        <div className="flex-1 flex flex-col gap-1">
          <div className="text-muted">Level</div>
          <div>{level}</div>
        </div>
        <div className="flex-1 flex flex-col gap-1">
          <div className="text-muted">Duration</div>
          <div className="flex items-baseline gap-2">
            <i className="pi pi-clock body-sm"></i>
            <span>{duration} mins</span>
          </div>
        </div>
      </div>
    </div>
  );
}
